<script>
    import AdminCard from "../ui/AdminCard.svelte";
    import {push} from "svelte-spa-router";
    import DefaultButton from "../../../components/DefaultButton.svelte";
    import {getSchemas} from "../../../api-client";
    import AuthGuard from "../../../common/AuthGuard.svelte";

    function logout() {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("userId");
        push("/login");
    }
</script>

<AuthGuard/>

<div class="admin-overview-page__wrapper">
    <div
            style="display: grid; grid-template-columns: 220px 220px 220px; grid-auto-rows: 280px; grid-gap: 16px"
    >
        {#await getSchemas() then schemas}
            {#each schemas as schema}
                <AdminCard
                        title={schema.displayName}
                        on:click={() => push("/admin/entities/" + schema.name)}
                />
            {/each}
        {/await}
    </div>

    <div style="width: 100%; max-width: 512px; padding: 32px 8px;">
        <DefaultButton
                on:click={() => push("/admin/settings")}
                text="Einstellungen"
        />

        <div class="divider-h" style="margin: 16px 0;"/>

        <DefaultButton on:click={logout} text="Logout"/>
    </div>
</div>

<style>
    .admin-overview-page__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 32px 0;
    }
</style>
